import { FormEvent, useState } from 'react';
import { Company } from '../api';
import { ErrorBox, Field, SourceBadge } from '../components/ui';

export type CompanyInput = Partial<Pick<Company, 'name' | 'tax_number' | 'registration_number' | 'address' | 'industry' | 'size' | 'website' | 'tags' | 'summary'>>;

const nn = (v: string) => (v.trim() === '' ? null : v.trim());

export function CompanyForm({ initial, onSubmit, onCancel, error, busy, summaryHint }: {
  initial?: Company; onSubmit: (v: CompanyInput) => void; onCancel?: () => void; error?: unknown; busy?: boolean; summaryHint?: string;
}) {
  const [v, setV] = useState({
    name: initial?.name ?? '', tax_number: initial?.tax_number ?? '', registration_number: initial?.registration_number ?? '',
    zip: initial?.address?.zip ?? '', city: initial?.address?.city ?? '', street: initial?.address?.street ?? '',
    industry: initial?.industry ?? '', size: initial?.size ?? '', website: initial?.website ?? '', tags: (initial?.tags ?? []).join(', '),
    summary: initial?.summary ?? '',
  });
  const set = (k: keyof typeof v) => (e: { target: { value: string } }) => setV({ ...v, [k]: e.target.value });
  const fs = initial?.field_sources ?? {};
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const address = v.zip || v.city || v.street ? { zip: v.zip.trim(), city: v.city.trim(), street: v.street.trim(), country: 'HU' } : null;
    onSubmit({
      name: v.name.trim(), tax_number: nn(v.tax_number), registration_number: nn(v.registration_number), address,
      industry: nn(v.industry), size: (nn(v.size) as any), website: nn(v.website),
      tags: v.tags.split(',').map((t) => t.trim()).filter(Boolean), summary: nn(v.summary),
    });
  };
  return (
    <form className="form" onSubmit={submit}>
      <div className="grid2">
        <Field label="Cégnév *"><input value={v.name} onChange={set('name')} required /><SourceBadge src={fs.name} /></Field>
        <Field label="Adószám" hint="12345678-1-12"><input value={v.tax_number} onChange={set('tax_number')} /><SourceBadge src={fs.tax_number} /></Field>
        <Field label="Cégjegyzékszám"><input value={v.registration_number} onChange={set('registration_number')} placeholder="01-09-123456" /></Field>
        <Field label="Weboldal"><input value={v.website} onChange={set('website')} /><SourceBadge src={fs.website} /></Field>
        <Field label="Irányítószám"><input value={v.zip} onChange={set('zip')} /></Field>
        <Field label="Település"><input value={v.city} onChange={set('city')} /></Field>
        <Field label="Utca, házszám"><input value={v.street} onChange={set('street')} /></Field>
        <Field label="Iparág"><input value={v.industry} onChange={set('industry')} /><SourceBadge src={fs.industry} /></Field>
        <Field label="Méret">
          <select value={v.size} onChange={set('size')}>
            <option value="">–</option><option value="1-9">1–9 fő</option><option value="10-49">10–49 fő</option>
            <option value="50-249">50–249 fő</option><option value="250+">250+ fő</option>
          </select>
        </Field>
        <Field label="Címkék" hint="vesszővel elválasztva"><input value={v.tags} onChange={set('tags')} /></Field>
      </div>
      <Field label="Kapcsolati összefoglaló" hint={summaryHint}><textarea rows={3} value={v.summary} onChange={set('summary')} /><SourceBadge src={fs.summary} /></Field>
      <ErrorBox error={error} />
      <div className="actions">
        <button type="submit" disabled={busy}>Mentés</button>
        {onCancel && <button type="button" className="secondary" onClick={onCancel}>Mégse</button>}
      </div>
    </form>
  );
}
